
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_18svc_17",
  "arrow": "awsui_arrow_18eso_18svc_17",
  "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_18svc_77",
  "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_18svc_77",
  "has-caret": "awsui_has-caret_18eso_18svc_113",
  "placeholder": "awsui_placeholder_18eso_18svc_116",
  "pressed": "awsui_pressed_18eso_18svc_132",
  "disabled": "awsui_disabled_18eso_18svc_138",
  "in-filtering-token": "awsui_in-filtering-token_18eso_18svc_77",
  "readonly": "awsui_readonly_18eso_18svc_159",
  "invalid": "awsui_invalid_18eso_18svc_182",
  "warning": "awsui_warning_18eso_18svc_191",
  "custom-option": "awsui_custom-option_18eso_18svc_200",
  "inline-tokens": "awsui_inline-tokens_18eso_18svc_205",
  "grouped": "awsui_grouped_18eso_18svc_208",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_18eso_18svc_214",
  "grouped-in-error": "awsui_grouped-in-error_18eso_18svc_221",
  "grouped-in-warning": "awsui_grouped-in-warning_18eso_18svc_226",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_18eso_18svc_256",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_18eso_18svc_293",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_18eso_18svc_335",
  "grouped-vertical-first": "awsui_grouped-vertical-first_18eso_18svc_382",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_18eso_18svc_424",
  "grouped-vertical-last": "awsui_grouped-vertical-last_18eso_18svc_461",
  "grouped-vertical-only": "awsui_grouped-vertical-only_18eso_18svc_503",
  "grouped-with-action": "awsui_grouped-with-action_18eso_18svc_550",
  "grouped-validation": "awsui_grouped-validation_18eso_18svc_554"
};
  